import React, { FC } from 'react';

import { alpha } from '@mui/material/styles';

import ConditionalBlockLink from '../../../components/ConditionalBlockLink/ConditionalBlockLink';
import { IKImage } from '../../../components/IKImage';
import { MetaText } from '../../../components/UI/Texts';
import styled from '../../../styled';
import { colorsPalette, MIDDLE_RADIUS_PX, SMALL_MARGIN_PX, TINY_MARGIN_PX } from '../../../theme';

const SRCSET = [{ width: 32 }];

interface DarkCardProps {
  title?: string | null;
  subtitle?: string | null;
  iconUrl?: string | null;
  link?: string | null;
}

const DarkCard: FC<DarkCardProps> = ({ title, subtitle, iconUrl, link }) => {
  return (
    <Wrapper withLink={link} to={link}>
      {iconUrl && <Icon srcset={SRCSET} sizes="100vw" path={iconUrl} />}
      <TextWrapper>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TextWrapper>
    </Wrapper>
  );
};

export default DarkCard;

const Wrapper = styled(ConditionalBlockLink)`
  display: flex;
  background: ${colorsPalette.blueDark};
  border-radius: ${MIDDLE_RADIUS_PX};
  cursor: ${({ withLink }) => (withLink ? 'pointer' : 'default')};
  padding: ${SMALL_MARGIN_PX};
`;

const Icon = styled(IKImage)`
  width: 32px;
  height: 32px;
  margin-right: ${TINY_MARGIN_PX};
`;

const TextWrapper = styled('div')``;

const Title = styled(MetaText)`
  color: ${colorsPalette.white};
  font-weight: bold;
`;

const Subtitle = styled(MetaText)`
  color: ${alpha(colorsPalette.white, 0.33)};
`;
